export const fr = {
  PrivacyPolicy: "Politique de confidentialité",
  PrivacyPolicyTitle: "Politique de confidentialité",
  Close: "Fermer",
  ClearReadNotifications: "Effacer les notifications lues",
  ContactUs: "Contactez-nous",
  NewsletterInvalidEmail: "Email invalide.",
  NewsletterSaveFailed: "Impossible d'enregistrer votre email. Réessayez.",
  NewsletterEmailPlaceholder: "Votre email",
  NewsletterCta: "S'inscrire",
  NewsletterSubmitting: "Inscription",
  NewsletterThanks: "Merci ! Vous êtes bien inscrit(e).",
  // fr
  SubscriptionCanceledTitle: "Abonnement annulé",
  SubscriptionCanceledMessage:
    "Votre abonnement a été annulé. Vous pouvez le renouveler à tout moment.",
  RenewSubscription: "Renouveler l'abonnement",
  AllSubscriptions: "Tous les abonnements",
  Subscription: "Abonnement",
  Customer: "Client",
  Price: "Prix",
  CancelScheduled: "Annulation programmée",
  ConfirmCancelSubscription:
    "Confirmer l'annulation de cet abonnement à la fin de la période ?",
  CancelNow: "Annuler à la fin de la période",
  PaymentSuccessMessage: "Votre abonnement Premium est maintenant actif.",
  GoToDashboard: "Aller au tableau de bord",
  PaymentCanceledTitle: "Paiement annulé",
  PaymentCanceledMessage: "Le paiement a été annulé. Vous pouvez réessayer.",
  TryAgain: "Réessayer",
  ManageSubscription: "Gérer l'abonnement",
  DarkModeOn: "Dark Mode activé",
  DarkModeOff: "Dark Mode désactivé",
  PremiumNeededForMoreProjects:
    "Le plan Gratuit autorise un seul projet. Passez au Premium pour en créer davantage.",
  Limit3CollaboratorsNonPremium:
    "Vous ne pouvez pas ajouter plus de 3 utilisateurs par projet si vous n'êtes pas Premium.",
  Limit3CollaboratorsReachedInvite:
    "Vous avez atteint la limite gratuite de {limit} collaborateurs. Passez au Premium pour en inviter davantage.",
  MonthlyTicketCapReached:
    "Vous avez atteint la limite mensuelle de {limit} tickets sur le plan Gratuit. Passez au Premium pour continuer Ã  crÃ©er des tickets.",
  FreePlanProjectLimit:
    "Sur le plan gratuit, vous ne pouvez créer qu'un seul projet.",
  ProjectLimitReached:
    "Limite de projets atteinte. Passez au Premium pour créer davantage de projets.",
  FreePlanTicketLimit:
    "Sur le plan gratuit, vous pouvez créer jusqu'à 40 tickets par mois.",
  TicketLimitReached:
    "Limite mensuelle de tickets atteinte (40). Passez au Premium pour des tickets illimités.",
  CurrentMonthTicketsCount: "Tickets créés ce mois-ci : {count}/40.",
  OnlyOneProjectOnFree: "Un seul projet est autorisé sur le plan gratuit.",
  FortyTicketsPerMonthOnFree:
    "Limite de 40 tickets par mois calendaire sur le plan gratuit.",
  MyTickets: "Mes tickets",
  SearchTicketsPlaceholder: "Rechercher des tickets (titre, description, n°)",
  YouArePremium: "Vous êtes Premium",
  PaymentSuccessTitle: "Paiement réussi",
  GoPremium: "Passer premium",
  HelpFAQs: "Aide & FAQs",
  TicketInsights: "Ticket Insights",
  Dashboard: "Statistiques",
  AvailableOnPremium: "Disponible sur le forfait premium",
  DetailAvailableOnPremium:
    "Accédez à plus de fonctionnalités en passant au plan premium",
  DetailComingSoon: "On travaille dessus",
  ComingSoon: "En construction",
  Brand: "Ticketize",
  NavOffer: "Notre offre",
  Pricing: "Tarifs",
  SignIn: "Se connecter",
  PricingPageTitle:
    "Tarifs Ticketize - Tickets gratuits, 5/mois pour passer à l'échelle",
  PricingPageMeta:
    "Offre gratuite pour petites équipes, 5/mois pour tickets, agents et alertes illimités. Ticketize est le SaaS de tickets le moins cher.",
  PricingTitle: "Nos Offres",
  PricingSubtitle: "Commencez gratuitement, passez au supérieur si besoin.",
  TierFreeName: "Gratuit",
  TierFreePrice: "0",
  TierFreeFeature1: "Jusqu'à 50 tickets/mois",
  TierFreeFeature2: "3 utilisateurs actifs",
  TierFreeFeature3: "Notifications in-app",
  TierFreeFeature4: "100 Mo de pièces jointes",
  TierFreeButton: "Commencer",
  TierPremiumName: "Premium",
  TierPremiumPrice: "5",
  TierPremiumFeature1: "Tickets & utilisateurs illimités",
  TierPremiumFeature2: "Notifications email & SMS",
  TierPremiumFeature3: "Analyses IA hebdomadaires",
  TierPremiumFeature4: "Webhooks & SSO",
  TierPremiumFeature5: "Branding perso & support prioritaire",
  TierPremiumButton: "Passer Premium",
  AboutPageTitle: "Ã€ propos de Ticketize - Durable",
  AboutPageMeta:
    "Découvrez comment Ticketize reste rentable : un plan gratuit généreux à 0$ de coût, et un premium à 5$/mois qui finance des fonctionnalitées avancées comme les alertes email/SMS et les analyses IA.",
  AboutHeroTitle: "Qui sommes-nous ?",
  AboutHeroSubtitle:
    "Chez Ticketize, notre mission est d'offrir aux petites entreprises un système de tickets complet et gratuit jusqu'à 50 tickets/mois, sans publicité.",
  AboutModelTitle: "Notre Modèle Durable",
  FreePlanTitle: "Plan Gratuit",
  FreePlanFeature1:
    "Jusqu'à 50 tickets/mois, largement suffisant pour la plupart des PME.",
  FreePlanFeature2:
    "Pas de bannières, pas de pièges, juste un service simple et fiable.",
  PremiumPlanTitle: "Plan Premium",
  PremiumPlanFeature1: "5$/mois pour tickets & utilisateurs illimités.",
  PremiumPlanFeature2: "Notifications email & SMS pour rester informé.",
  PremiumPlanFeature3:
    "Analyses hebdomadaires IA : vos problèmes fréquents identifiés automatiquement.",
  WhyChooseTitle: "Pourquoi choisir Ticketize?",
  WhyChooseFeature1Title: "Démarrage Zéro Coût",
  WhyChooseFeature1Desc:
    "Des centaines d'entreprises utilisatrices sans dépenser un centime.",
  WhyChooseFeature2Title: "Premium évolutif",
  WhyChooseFeature2Desc:
    "Un plan généreux à 5$/mois qui s'adapte à vos besoins.",
  WhyChooseFeature3Title: "Analyses IA Automatisées",
  WhyChooseFeature3Desc:
    "Rapports hebdomadaires pour cibler les problèmes récurrents.",
  HeroTitlePart1: "Le SaaS de tickets le plus simple",
  HeroTitlePart2: "gratuit pour les petites équipes",
  HeroHighlight: "Ticketize",
  HeroTitleFull:
    "Ticketize - Le SaaS de tickets de support le plus simple, gratuit pour les petites équipes",
  HeroMetaDescription:
    "Ticketize est le SaaS de tickets le plus simple : gratuit pour les petites équipes, coût le plus bas pour évoluer, flux épurés, agents illimités à 5 euros/mois.",
  HeroSubtitle:
    "Centralisez les demandes, assignez et résolvez plus vite. Démarrez gratuit ; agents illimités à 5 euros/mois.",
  HeroPrimaryCta: "Créer mon compte gratuit",
  HeroPrimaryCtaHelper:
    "Votre compte Google suffit pour commencer en quelques minutes.",
  EmailPlaceholder: "Votre email",
  ButtonDemo: "Demandez une démo",
  HeroImageAlt: "Aperçu du tableau de bord Ticketize",
  FeatureZeroCost: "Fonctionnalités gratuites et sans pub",
  FeatureEase: "Mise en place et usage simplifiés",
  FeaturePremiumValue: "Premium à 5$/mo avec insights IA",
  DeleteTicket: "Supprimer le Ticket",
  ConfirmDeleteTicket: "Etes vous sur de vouloir supprimer le ticket ?",
  EditPicture: "Modifier la photo",
  Welcome: "Bienvenue",
  WhoAreWe: "Qui sommmes nous?",
  All: "Tous",
  AdminNoProjectsYet: "Aucun projet pour le moment",
  NoProjectSelected: "Aucun projet sélectionné",
  GetStartedByCreatingProject: "Commencez par créer un projet",
  TicketAddedSuccessfully: "Ticket ajouté avec succès",
  FailedToAddTicket: "Echec de lajout du ticket",
  TicketUpdatedSuccessfully: "Ticket mis à jour avec succÃ¨s",
  FailedToUpdateTicket: "chec de la mise à jour du ticket",
  OnlyCreatorCanEdit: "Seul le créateur ou un admin peut modifier ce ticket",
  AttachmentsSaved: "Pièces jointes enregistrées",
  SelectProject: "Veuillez sélectionner un projet",
  MustBeActiveUser:
    "Vous devez être un utilisateur actif pour effectuer cette action",
  PriorityError: "Priorité",
  InvalidEmail: "Veuillez entrer une adresse email valide",
  EmailAlreadyInvited: "Cet email a déjà été invité",
  AlreadyMemberOfACompany: "Cet utilisateur appartient déjà à une entreprise",
  InviteFailed: "Echec de l'envoi de l'invitation",
  RoleUpdated: "Rôle mis à jour avec succÃ¨s",
  RoleUpdateFailed: "Echec de la mise à jour du rôle",
  PhotoUploadFailed: "Echec du téléchargement de la photo",
  UserDeletedSuccessfully: "Utilisateur supprimé avec succès",
  UserDeleteFailed: "Echec de la suppression de l'utilisateur",
  ProjectUpdated: "Projet mis à jour avec succÃ¨s",
  ProjectDeletedConfirm: "Etes-vous sûr de vouloir supprimer ce projet ?",
  Logout: "Déconnexion",
  ConfirmLogout: "Confirmer la déconnexion ?",
  NoMemberToAdd: "Vous pouvez ajouter un membre (optionnel).",
  OptionalMemberInfo: "Vous pouvez ajouter un membre (optionnel).",
  ExplainationAddProject:
    "Entrez un nom de projet ainsi que les utilisateurs que vous voulez attacher à ce projet",
  NoProjects: "Pas de projet créé pour le moment",
  InviteSent: "Invitation envoyée",
  AttachedFiles: "FICHIER(S) JOINT(S)",
  SendAMessage: "Envoyer un message",
  InviteByEmail: "Inviter un utilisateur par email",
  EmailAddress: "Adresse email",
  NoTicketsInTabMessage:
    "Sélectionnez un autre onglet pour voir s'il y a des tickets",
  NoTicketsInTab: "Pas de ticket pour ce statut pour ce projet",
  TryAnotherProjectOrTab:
    "Sélectionnez/ajoutez un projet en haut ou changez d'onglet",
  ChooseAProject: "Choisissez un projet",
  SaveAttachments: "Mettre à jour",
  Done: "Terminé",
  MaxFileSize: "Taille max. de fichier : ",
  DragAndDropOrBrowse: "Glisser et déposer ou Sélectionner un fichier",
  UploadFiles: "Télécharger le(s) fichier(s)",
  ManageFile: "Ajouter/retirer fichier(s)",
  Closed: "Fermé",
  InReview: "En revue",
  InTest: "En test",
  InProduction: "En production",
  InStaging: "En recette",
  UserComment: "Commentaire utilisateur",
  Open: "Ouvert",
  WorkingOnIt: "En cours",
  StatusChangedOpen: "Statut : Ouvert",
  StatusChangedClosed: "Statut : Fermé",
  TicketCreated: "Ticket créé",
  AdminComment: "Commentaire admin",
  PriorityChanged: "Priorité modifiée",
  TicketActivity: "Activité du ticket",
  NoActivityYet: "Pas encore d'activité",
  AddComment: "Ajouter un commentaire",
  PostComment: "Publier le commentaire",
  Incident: "Incident",
  Problem: "Problème",
  Question: "Question",
  Suggestion: "Suggestion",
  Evolution: "Evolution",
  Bug: "Anomalie",
  Feature: "Fonctionnalité",
  Improvement: "Amélioration",
  ChangeRequest: "Demande de changement",
  Task: "Tâche",
  Low: "Faible",
  Medium: "Moyenne",
  High: "Elevée",
  PriorityForm: "Priorité",
  TicketNameForm: "Nom du ticket",
  RequiredField: "Champ obligatoire",
  TicketTypeError: "Type du ticket",
  WriteDescriptionError: "Description du ticket",
  TicketNameError: "Nom du ticket",
  MissingFields: "CHAMPS MANQUANTS",
  Type: "TYPE",
  Project: "PROJET",
  Creator: "CRééPAR",
  Save: "Enregistrer",
  OptionalMessage: "Message (facultatif)",
  SelectMembers: "Sélectionnez le(s) membre(s)",
  ProjectMembers: "Membres du projet",
  EditProject: "Modifier le projet",
  ProjectCreated: "Projet créé",
  Create: "Créer",
  CommaSeparated: "Séparé par des virgules",
  PageListCategories: "Listes des types de pages",
  ProjectName: "Nom du projet",
  AddProject: "Ajouter un projet",
  ContactAdminsAt: "Merci de contacter l'administrateur à l'adresse ",
  YouAreSuspended: "Votre compte a été suspendu",
  AddAProject: "Ajouter un projet",
  ProjectsList: "LISTE DES PROJETS",
  Pending: "En attente",
  TeamMembers: "MEMBRE(S) DE L'EQUIPE",
  JoinedOn: "Inscrit(e) le",
  SendInvite: "Envoyer l'invitation",
  EmailAlreadyExists: "Une invitation a déjà été envoyée à cet email",
  ProfileFormDescription:
    "Merci de bien vouloir renseigner le nom de votre société, pour pouvoir vous rattacher vous et votre équipe à cette entité",
  NoColleagues: "Personne de votre équipe pour le moment",
  Company: "Société",
  PleaseFillYourCompanyName: "Merci de saisir le nom de votre société",
  CompleteYourProfile: "Quel est le nom de votre société ?",
  PleaseFillYourCompanyNameFirst: "Saisir d'abord le nom de votre société",
  Confirm: "Valider",
  InviteUser: "Invitez un utilisateur",
  YourUserProfil: "Votre profil utilisateur",
  UserProfile: "Profil utilisateur",
  YourColleagues: "Membres de l'équipe",
  NoTicketsToShow: "Pas de ticket pour ce projet / Pas de projet sélectionné",
  NoProjectNormal: "Pas de projets pour le moment ",
  Projects: "Projets",
  SuccessfullyLoggedInWithGoogle: "Connecté via Google avec succès",
  Signout: "Déconnexion",
  UpdateTicket: "Mise à jour du ticket",
  performedBy: "Traité par:",
  Deleting: "Suppression...",
  AreYouSureToDeleteTicket: "Etes vous sur de vouloir supprimer ce ticket ?",
  ErrorDeletingTicket: "Problème lors de la suppression du ticket:",
  TicketSuccessfullyDeleted: "Ticket supprimé avec succès",
  Delete: "Supprimer",
  Edit: "Editer",
  Cancel: "Annuler",
  TicketType: "TYPE DE TICKET",
  WriteDescription: "DESCRIPTION DU PROBLEME",
  Reset: "RÃ©initialiser",
  CreatedAt: "CREE LE",
  Status: "STATUT",
  PageConcerned: "ELEMENT CONCERNE",
  Priority: "PRIORITEE",
  TicketName: "NOM DU TICKET",
  TicketNumber: "# TICKET ",
  Select: "Sélectionnez",
  LatestSupportTickets: "Derniers tickets postés",
  AddNewTicket: "Ajouter un ticket",
  PleaseSendTicket: "Merci de soumettre un ticket",
  SupportTickets: "Tickets de support",
  WelcomeToTicketHub: "Bienvenue sur Ticketize",
  LogInWithGoogle: "Se connecter avec Google",
  OnboardingTitle: "Quelques questions rapides",
  OnboardingSubtitle: "Cela nous aide à améliorer Ticketize dès le lancement.",
  OnboardingBack: "Retour",
  OnboardingNext: "Continuer",
  OnboardingFinish: "Terminer",
  OnboardingStepLabel: "Étape",
  OnboardingQuestionAcquisition: "Comment nous avez-vous trouvés ?",
  OnboardingQuestionUsage: "Vous allez utiliser Ticketize pour quel usage ?",
  OnboardingQuestionIndustry: "Dans quel secteur êtes-vous ?",
  OnboardingOptionGoogle: "Google",
  OnboardingOptionChatgpt: "ChatGPT",
  OnboardingOptionReddit: "Reddit ou similaire",
  OnboardingOptionOther: "Autre",
  OnboardingOptionPro: "Usage professionnel",
  OnboardingOptionPersonal: "Usage personnel",
  OnboardingOptionTech: "Tech / SaaS / Agence digitale",
  OnboardingOptionEcommerce: "E-commerce / Retail / Services en ligne",
  OnboardingOptionLocal: "Services locaux / PME",
  OnboardingOptionOtherIndustry: "Autre secteur",
};
